<!--
/**
 * DjRechargeTab.vue - 充值 Tab 组件
 *
 * 【功能说明】
 * 本组件是迪加(DJ)虚拟商品管理系统的充值管理页面，提供号码充值、
 * 异常充值、APP充值开关管理、充值记录查询、返销、下载等功能。
 *
 * 【主要功能】
 * 1. 充值记录查询 - 按代理商、企业、号码、流水号、状态等条件查询充值记录
 * 2. 普通充值 - 输入手机号和金额进行充值
 * 3. 异常充值 - 对异常号码进行特殊充值操作
 * 4. APP充值管理 - 开启/关闭APP充值功能
 * 5. 返销操作 - 对已充值的记录进行返销（撤销充值）
 * 6. 下载功能 - 下载指定批次的充值数据
 * 7. 复制功能 - 点击复制流水号
 *
 * 【权限要求】
 * - 所有用户：可查询充值记录、进行充值操作
 -->
<template>
  <div>
    <!-- ========== 搜索区域 ========== -->
    <div class="handle-box">
      <!-- 代理商下拉选择框（可搜索、可清除） -->
      <el-select size="small" @change="onAgentChange" v-model="singlequery.agentId" filterable clearable
                 placeholder="请选择代理商" class="handle-select mr10" style="width: 260px;">
        <el-option v-for="item in agents" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- 企业下拉选择框（选择代理商后会联动更新企业列表） -->
      <el-select size="small" style="width: 260px;" v-model="singlequery.companyId" filterable clearable
                 placeholder="企业" class="handle-select mr10">
        <el-option v-for="item in companys" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- 号码输入框 -->
      <el-input size="small" v-model="singlequery.phone" clearable maxlength="12" placeholder="号码"
                style="width: 180px;" class="handle-input mr10"></el-input>
      <!-- 流水号输入框 -->
      <el-input size="small" v-model="singlequery.uid" clearable placeholder="流水号" style="width: 350px;"
                class="handle-input mr10"></el-input>
      <!-- 状态下拉选择框（全部/成功/失败） -->
      <el-select size="small" style="width: 100px" v-model="singlequery.status" filterable clearable
                 placeholder="状态" class="handle-select mr10">
        <el-option v-for="item in statusList" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- 搜索按钮 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" @click="topUpRecord"
                 class="m_t_10">搜索
      </el-button>
      <!-- 充值按钮 - 打开普通充值弹窗 -->
      <el-button size="small" type="primary" :class="[theme]" @click="getAdd"
                 class="m_t_10">充值
      </el-button>
      <!-- 异常充值按钮 - 打开异常充值弹窗 -->
      <el-button size="small" type="warning" :class="[theme]" @click="getAbnormalAdd"
                 class="m_t_10">异常充值
      </el-button>
      <!-- APP充值按钮 - 打开APP充值设置弹窗 -->
      <el-button size="small" type="primary" :class="[theme]" @click="getAPPAdd"
                 class="m_t_10">APP充值
      </el-button>
    </div>

    <!-- ========== 充值记录表格 ========== -->
    <el-table :data="singletableData" border class="table" ref="multipleTable"
              header-cell-class-name="table-header" :row-style="{ height: '20px' }"
              :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
              v-loading="loading">
      <!-- 代理商名称 -->
      <el-table-column prop="agentName" label="代理商" align="center" min-width="180"></el-table-column>
      <!-- 企业名称 -->
      <el-table-column prop="companyName" label="企业" align="center" min-width="180"></el-table-column>
      <!-- 充值的手机号 -->
      <el-table-column prop="phone" label="用户名" align="center" width="130"></el-table-column>
      <!-- 充值金额 -->
      <el-table-column prop="amount" label="金额(元)" align="center" width="90"></el-table-column>
      <!-- 充值状态（失败时红色显示，悬浮提示失败原因） -->
      <el-table-column prop="status" label="状态" align="center" width="90">
        <template #default="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.errMsg" placement="top"
                      v-if="scope.row.status == '失败'">
            <span style="color: #f56c6c;">{{ scope.row.status }}</span>
          </el-tooltip>
          <span v-else>{{ scope.row.status }}</span>
        </template>
      </el-table-column>
      <!-- 充值时间 -->
      <el-table-column prop="createdAt" label="时间" width="180" align="center"></el-table-column>
      <!-- 操作者 -->
      <el-table-column prop="userPhone" label="操作者" align="center" width="130"></el-table-column>
      <!-- 流水号列（含下载、复制、返销操作） -->
      <el-table-column label="流水号" width="400" align="center">
        <template #default="scope">
          <span style="cursor: pointer;">
            <!-- 下载按钮 - 下载该批次的充值数据 -->
            <i @click="gettopUpRecordDownload(scope.row.uid)" class="el-icon-download"
               :class="[theme3]" style="margin-right:10px;font-weight: 600;"></i>
            <!-- 流水号（点击可复制） -->
            <span @click="copyUrl(scope.row.uid)">{{ scope.row.uid }}</span>
            <!-- 返销按钮 - 撤销该笔充值 -->
            <span @click="getReturnPremium(scope.row)"
                  style="margin-left: 10px;color: #ff0000;">返销</span>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!-- ========== 分页器 ========== -->
    <div class="pagination">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                     :current-page="singlequery.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                     :page-size="singlequery.pageSize" :total="singletotal" @size-change="singlehandleSizeChange"
                     @current-change="singlehandlePageChange"></el-pagination>
    </div>

    <!-- ========== 充值弹窗 ========== -->
    <!-- 普通充值：输入手机号和金额进行充值 -->
    <el-dialog title="充值" v-model="singleVisible" width="450px" @close="closesingleDialog">
      <el-form label-width="120px" :model="singleForm" ref="editForm">
        <!-- 手机号输入 -->
        <el-form-item label="手机号">
          <el-input size="small" style="width: 250px;" placeholder="请输入手机号"
                    v-model="singleForm.phone"></el-input>
        </el-form-item>
        <!-- 充值金额输入（只允许输入数字） -->
        <el-form-item label="添加金额">
          <el-input v-model="singleForm.amount" size="small" style="width: 250px;" placeholder="请输入金额"
                    oninput="value=value.replace(/[^0-9]/g,'')"/>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closesingleDialog">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="AddtopUp">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- ========== 异常充值弹窗 ========== -->
    <!-- 对异常号码进行特殊充值操作 -->
    <el-dialog title="异常充值" v-model="abnormalVisible" width="450px" @close="closeAbnormalDialog">
      <el-form label-width="120px" :model="abnormalForm" ref="abnormalForm">
        <el-form-item label="手机号">
          <el-input size="small" style="width: 250px;" placeholder="请输入手机号"
                    v-model="abnormalForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="添加金额">
          <el-input v-model="abnormalForm.amount" size="small" style="width: 250px;" placeholder="请输入金额"
                    oninput="value=value.replace(/[^0-9]/g,'')"/>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeAbnormalDialog">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="doAbnormalTopUp">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- ========== APP充值设置弹窗 ========== -->
    <!-- 开启或关闭APP充值功能 -->
    <el-dialog title="APP充值" v-model="APPVisible" width="450px" @close="closeAPPDialog">
      <el-form label-width="120px" :model="APPForm" ref="editForm">
        <el-form-item label="APP充值:" prop="bon">
          <el-radio-group v-model="APPForm.bon">
            <el-radio :label="true">开启</el-radio>
            <el-radio :label="false">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeAPPDialog">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="getstopDxtApp">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 充值 Tab 组件脚本部分
 *
 * 引入的 API 接口：
 * - fetchCompanyByAgentId：根据代理商ID获取企业列表
 * - fetchDefaultCompanies：获取默认企业列表
 * - topUpRecord：查询充值记录
 * - AddtopUp：普通充值
 * - AbnormalTopUp：异常充值
 * - stopDxtApp：设置APP充值开关
 * - dxtEnabled：查询APP充值当前状态
 * - ReturnPremium：返销充值
 * - topUpRecordDownload：下载充值记录
 */
import {
  fetchCompanyByAgentId,
  fetchDefaultCompanies
} from '../../../api/companyIndex';
import {
  topUpRecord,
  AddtopUp,
  AbnormalTopUp,
  stopDxtApp,
  dxtEnabled,
  ReturnPremium,
  topUpRecordDownload
} from '../../../api/dijia.js';

export default {
  name: 'DjRechargeTab',

  /**
   * 【Props 接收的参数】
   * - theme：主题颜色样式类名
   * - theme3：辅助主题颜色类名
   * - agents：代理商列表（用于下拉筛选）
   */
  props: {
    theme: { type: String, default: '' },
    theme3: { type: String, default: '' },
    agents: { type: Array, default: () => [] },
  },

  data() {
    return {
      // ========== 查询相关 ==========
      loading: false,           // 表格加载状态
      companys: [],             // 企业列表（根据代理商联动加载）
      singlequery: {            // 充值记录查询参数
        pageIndex: 1,           // 当前页码
        pageSize: 10,           // 每页条数
        userId: localStorage.getItem('user'),  // 当前用户ID
        uid: '',                // 流水号筛选
        status: '',             // 状态筛选
        agentId: '',            // 代理商ID筛选
        companyId: '',          // 企业ID筛选
      },
      singletableData: [],      // 充值记录表格数据
      singletotal: 0,           // 充值记录总条数
      statusList: [             // 状态筛选选项列表
        { value: 0, label: '全部' },
        { value: 1, label: '成功' },
        { value: -1, label: '失败' }
      ],

      // ========== 普通充值弹窗相关 ==========
      singleVisible: false,     // 充值弹窗是否显示
      singleForm: {             // 充值表单数据
        userId: localStorage.getItem('user'),
        phone: '',              // 充值手机号
        amount: '',             // 充值金额
      },

      // ========== 异常充值弹窗相关 ==========
      abnormalVisible: false,   // 异常充值弹窗是否显示
      abnormalForm: {           // 异常充值表单数据
        userId: localStorage.getItem('user'),
        phone: '',              // 异常充值手机号
        amount: '',             // 异常充值金额
      },

      // ========== APP充值设置弹窗相关 ==========
      APPVisible: false,        // APP充值弹窗是否显示
      APPForm: {
        bon: false,             // APP充值开关状态（true=开启，false=关闭）
      },
    };
  },

  /**
   * 组件创建时的生命周期钩子
   * 1. 初始化企业列表
   * 2. 查询充值记录
   */
  created() {
    this.initCompanies();
    this.topUpRecord();
  },

  methods: {
    /**
     * initCompanies - 初始化企业列表
     * 获取当前用户下所有企业，用于企业下拉选择框
     */
    initCompanies() {
      let data = {
        currentUserId: localStorage.getItem('user'),
        subAgentId: ''
      };
      fetchDefaultCompanies(data).then(res => {
        if (res?.code === 200) {
          this.companys = res.data;
        }
      });
    },

    /**
     * onAgentChange - 代理商选择变化回调
     * 切换代理商时清空企业选择，并根据新代理商加载对应企业列表
     * @param {string} agentId - 选中的代理商ID
     */
    onAgentChange(agentId) {
      this.singlequery.agentId = agentId;
      this.singlequery.companyId = '';
      if (agentId) {
        let data = {
          subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
          agentId: agentId
        };
        fetchCompanyByAgentId(data).then(res => {
          this.companys = res.data;
        });
      } else {
        // 未选择代理商时加载默认企业列表
        this.initCompanies();
      }
    },

    /**
     * topUpRecord - 查询充值记录
     * 根据当前查询参数（代理商、企业、号码、流水号、状态）获取充值记录列表
     */
    topUpRecord() {
      topUpRecord(this.singlequery).then(res => {
        if (res?.code === 200) {
          this.singletableData = res.data.list;
          this.singletotal = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * getAdd - 打开普通充值弹窗
     */
    getAdd() {
      this.singleVisible = true;
    },

    /**
     * closesingleDialog - 关闭普通充值弹窗
     * 清空表单数据
     */
    closesingleDialog() {
      this.singleForm.amount = '';
      this.singleForm.phone = '';
      this.singleVisible = false;
    },

    /**
     * AddtopUp - 提交普通充值
     * 将手机号和金额提交到后端进行充值，成功后关闭弹窗并刷新记录
     */
    AddtopUp() {
      let data = {
        phone: this.singleForm.phone,
        amount: this.singleForm.amount,
        userId: localStorage.getItem('user')
      };
      AddtopUp(data).then(res => {
        if (res?.code === 200) {
          this.$message.success(res.data);
          setTimeout(() => {
            this.singleVisible = false;
            this.topUpRecord();
          }, 1000);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * getAbnormalAdd - 打开异常充值弹窗
     */
    getAbnormalAdd() {
      this.abnormalVisible = true;
    },

    /**
     * closeAbnormalDialog - 关闭异常充值弹窗
     * 清空表单数据
     */
    closeAbnormalDialog() {
      this.abnormalForm.amount = '';
      this.abnormalForm.phone = '';
      this.abnormalVisible = false;
    },

    /**
     * doAbnormalTopUp - 提交异常充值
     * 将手机号和金额提交到后端进行异常充值，成功后关闭弹窗并刷新记录
     */
    doAbnormalTopUp() {
      let data = {
        phone: this.abnormalForm.phone,
        amount: this.abnormalForm.amount,
        userId: localStorage.getItem('user')
      };
      AbnormalTopUp(data).then(res => {
        if (res?.code === 200) {
          this.$message.success(res.data);
          setTimeout(() => {
            this.abnormalVisible = false;
            this.topUpRecord();
          }, 1000);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * getAPPAdd - 打开APP充值设置弹窗
     * 先查询当前APP充值状态，再显示弹窗
     */
    getAPPAdd() {
      this.APPVisible = true;
      this.getdxtEnabled();
    },

    /**
     * closeAPPDialog - 关闭APP充值设置弹窗
     */
    closeAPPDialog() {
      this.APPVisible = false;
    },

    /**
     * getstopDxtApp - 提交APP充值开关设置
     * 开启或关闭APP充值功能
     */
    getstopDxtApp() {
      let data = {
        bon: this.APPForm.bon,
        userId: localStorage.getItem('user')
      };
      stopDxtApp(data).then(res => {
        if (res?.code === 200) {
          this.$message.success(res.data);
          this.APPVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * getdxtEnabled - 查询APP充值当前开关状态
     * 将返回的开关状态设置到APPForm.bon中
     */
    getdxtEnabled() {
      dxtEnabled().then(res => {
        if (res?.code === 200) {
          this.APPForm.bon = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * getReturnPremium - 执行返销操作
     * 弹出确认框后对指定充值记录进行返销（撤销充值）
     * @param {Object} row - 充值记录行数据
     */
    getReturnPremium(row) {
      this.$confirm('确定要返销该批次数据吗？', '提示', { type: 'warning' })
        .then(() => {
          let data = {
            userId: localStorage.getItem('user'),
            uid: row.uid,
            phone: row.phone
          };
          ReturnPremium(data).then(res => {
            if (res?.code === 200) {
              this.$message.success(res.message);
              this.topUpRecord();
            } else {
              this.topUpRecord();
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    /**
     * gettopUpRecordDownload - 下载指定批次的充值数据
     * 弹出确认框后下载该批次数据文件
     * @param {string} uid - 充值流水号
     */
    gettopUpRecordDownload(uid) {
      this.$confirm('确定要下载该批次数据吗？', '提示', { type: 'warning' })
        .then(() => {
          let data = { uid: uid };
          topUpRecordDownload(data).then(res => {
            // 创建隐藏的 <a> 标签触发下载
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = res.data;
            document.body.appendChild(link);
            link.click();
          });
        })
        .catch(() => {});
    },

    /**
     * copyUrl - 复制文本到剪贴板
     * 通过创建临时input元素实现复制功能
     * @param {string} item - 要复制的文本内容
     */
    copyUrl(item) {
      let cInput = document.createElement('input');
      cInput.value = item;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.$message.success('复制成功');
      document.body.removeChild(cInput);
    },

    /**
     * singlehandlePageChange - 翻页回调
     * @param {number} val - 新的页码
     */
    singlehandlePageChange(val) {
      this.singlequery.pageIndex = val;
      this.topUpRecord();
    },

    /**
     * singlehandleSizeChange - 每页条数变化回调
     * @param {number} val - 新的每页条数
     */
    singlehandleSizeChange(val) {
      this.singlequery.pageSize = val;
      this.singlequery.pageIndex = 1;
      this.topUpRecord();
    },
  }
};
</script>

<style scoped>
@import './tab-styles.css';
</style>
